<script>

export default {
  data() {
    return {
      currentdata: "",
      components: {
        health: {
          title: "health",
          solutions: ["hds", "cybersecurity", "hosting"]
        },
        finance: {
          title: "finance",
          solutions: ["pci", "cybersecurity"]
        },
        souverainete: {
          title: "souverainete",
          solutions: ["sovereign", "cybersecurity", "cloud", "certified"]
        },
        innovation: {
          title: "innovation",
          solutions: ["proximity", "connectivity"]
        }
      }
    }
  },
  created() {
    this.updatePath();
  },

  methods: {
    updatePath() {
      switch (this.$router.currentRoute.path) {
        case "/gamme-sante":
          this.currentdata = "health"
          break
        case "/gamme-souverainete":
          this.currentdata = "souverainete"
          break
        case "/gamme-finance":
          this.currentdata = "finance"
          break
        case "/gamme-innovation":
          this.currentdata = "innovation"
          break
        default:
          this.$router.push("/404")
      }
    }
  },

  watch: {
    '$router.currentRoute.path': function () {
      this.updatePath()
    }
  }
}
</script>
<template>
  <div class="container-fluid base-container text-center">
    <p class="accroche" v-html="$t('gammes.'+components[currentdata].title+'.title')"></p>

    <p class="subtext">{{ $t('gammes.' + components[currentdata].title + '.subtext') }}</p>

    <div class="container-fluid " style="text-align: justify; max-width: 1400px;">
      <p class="normal"> {{ $t('gammes.' + components[currentdata].title + '.preshot') }}</p>
      <p class="accroche text-center" v-html="$t('gammes.solutions_title')"></p>


      <div v-for="(d, index) in components[currentdata].solutions" v-bind:key="index">
        <hr style="color: #ccc; margin: 50px 5px;" v-if="index !== 0">

        <h3 style="text-align: left"><i class="far fa-flag"></i>
          {{ $t('gammes.' + components[currentdata].title + '.solutions.' + d + '.title') }}
        </h3>

        <div class="normal"
             v-if="$t('gammes.'+components[currentdata].title+'.solutions.'+d+'.subtext') !== 'gammes.'+components[currentdata].title+'.solutions.'+d+'.subtext'">
          {{ $t('gammes.' + components[currentdata].title + '.solutions.' + d + '.subtext') }}
        </div>

        <div
            v-if="$t('gammes.'+components[currentdata].title+'.solutions.'+d+'.listing') !== 'gammes.'+components[currentdata].title+'.solutions.'+d+'.listing'"
            class="normal" v-html="$t('gammes.'+components[currentdata].title+'.solutions.'+d+'.listing')">
        </div>

        <div class="normal"
             v-if="$t('gammes.' + components[currentdata].title + '.solutions.' + d + '.posttext') !== 'gammes.' + components[currentdata].title + '.solutions.' + d + '.posttext'"
             v-html="$t('gammes.' + components[currentdata].title + '.solutions.' + d + '.posttext')">
        </div>

      </div>

    </div>
  </div>
</template>


<style scoped>
ul {
  font-size: 18px;
}

h3 {
  color: #33e091 !important;
}

h3 i {
  padding-right: 15px;
}

h3, h4, ul, li {
  color: #f7f7f7;
}

.normal {
  font-size: 18px;
  color: #f7f7f7
}

.base-container {
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.1)), url('/images/bg1.webp');
  background-attachment: fixed;
  padding-top: 100px;
  padding-bottom: 100px
}

.base-container .subtext {
  font-size: 24px;
  font-family: 'Prompt', sans-serif;
  color: #f7f7f7;
  margin-bottom: 70px;
}

.subtext {
  margin-top: -50px
}

</style>
